import BaseField from "./BaseField";
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import React from 'react';

class ReCaptchaFieldComponent extends BaseField{
    constructor(props) {
        super(props);
        this.state = {
            isVerified: false,
            isLoading: false
        };
        this.executeRecaptcha = this.executeRecaptcha.bind(this);
    }

    componentDidMount() {
        // Execute reCAPTCHA when component mounts with a delay to ensure script is loaded
        this.executeRecaptcha();
    }

    async executeRecaptcha(retryCount = 0) {
        const { googleReCaptchaProps } = this.props;
        const maxRetries = 5;
        const retryDelay = 1000; // 1 second

        if (!googleReCaptchaProps || !googleReCaptchaProps.executeRecaptcha) {
            if (retryCount < maxRetries) {
                // Retry after delay if reCAPTCHA script is still loading
                setTimeout(() => {
                    this.executeRecaptcha(retryCount + 1);
                }, retryDelay);
                return;
            } else {
                console.error('Execute recaptcha function not available after retries');
                this.props.collectData(this.props.id, false);
                this.setState({
                    isVerified: false,
                    isLoading: false
                });
                return;
            }
        }

        this.setState({ isLoading: true });

        try {
            // Execute reCAPTCHA and get token
            const token = await googleReCaptchaProps.executeRecaptcha('submit');

            if (token) {
                // Set field value to true for successful validation
                this.props.collectData(this.props.id, true);
                this.setState({
                    isVerified: true,
                    isLoading: false
                });
            } else {
                // Set field value to false for failed validation
                this.props.collectData(this.props.id, false);
                this.setState({
                    isVerified: false,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('ReCAPTCHA execution failed:', error);
            this.props.collectData(this.props.id, false);
            this.setState({
                isVerified: false,
                isLoading: false
            });
        }
    }

    render() {
        const { isVerified, isLoading } = this.state;

        return (
            <div className={this.props.Columns}>
                <div className="field recaptcha">
                    {/*<div className="recaptcha-status">
                        {isLoading && <span>Verifying...</span>}
                        {!isLoading && isVerified && <span>✓ Verified</span>}
                        {!isLoading && !isVerified && <span>Verification required</span>}
                    </div>*/}
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}

// Wrap the component with GoogleReCaptchaProvider and withGoogleReCaptcha HOC
export class ReCaptchaField extends React.Component {
    render() {
        return (
            <GoogleReCaptchaProvider reCaptchaKey={this.props.SiteKey}>
                <ReCaptchaFieldWithRecaptcha {...this.props} />
            </GoogleReCaptchaProvider>
        );
    }
}

const ReCaptchaFieldWithRecaptcha = withGoogleReCaptcha(ReCaptchaFieldComponent);

export default ReCaptchaField;
